import { render, staticRenderFns } from "./courseInfo.vue?vue&type=template&id=81719e5a&scoped=true&"
import script from "./courseInfo.vue?vue&type=script&lang=js&"
export * from "./courseInfo.vue?vue&type=script&lang=js&"
import style0 from "./courseInfo.vue?vue&type=style&index=0&id=81719e5a&lang=scss&scoped=true&"
import style1 from "./courseInfo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81719e5a",
  null
  
)

export default component.exports